import React, { useState, useRef, useEffect } from 'react';
import './CreatePostDropdown.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  isCorporateVerified,
  VERIFY_CORPORATE_EMAIL_NAV_STATE,
} from "../../corporateVerification.js";

const CreatePostDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { userDetails } = useSelector((state) => state.userReducer);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const navigate = useNavigate()

  const goCreate = (path) => {
    if (!isCorporateVerified(userDetails)) {
      navigate('/profile', { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
      setIsOpen(false);
      return;
    }
    navigate(path);
    setIsOpen(false);
  };

  return (
    <div className="create-post-container" ref={dropdownRef}>
      <button
        className="create-post-button Button1"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="plus-icon">+</span> Create a Post
      </button>

      <button
        className="create-post-button Button2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="plus-icon">+</span> New
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-item" onClick={() => goCreate('/createRental')}>Create Rentals</div>
          <div className="dropdown-item" onClick={() => goCreate('/createCommerceListing')}>Create Commerce</div>
          <div className="dropdown-item" onClick={() => goCreate('/createOtherListing')}>Create Others</div>
        </div>
      )}
    </div>
  );
};

export default CreatePostDropdown;
